<wuc-drop-trigger position="bottom" balloonHorizontalAlignment="center">
    <wuc-button [small]="true" [disabled]="!purchasedProduct" iconRight="arrow-down-bold">Direct regelen</wuc-button>
    <wuc-balloon padding="medium">
        <wuc-rack>
            <wuc-button
                *ngFor="let directControlButton of directControlButtons"
                type="secondary"
                [small]="true"
                [disabled]="directControlButton.disabled"
                [isFullWidth]="true"
                (click)="onClick(directControlButton)"
            >
                {{ directControlButton.name }}
            </wuc-button>
        </wuc-rack>
    </wuc-balloon>
</wuc-drop-trigger>
